export function getCalculatingHeightTable(wrapper) {
  const layoutElement = wrapper.parentElement.parentElement.parentElement
  const layoutElementPadding = parseInt(window.getComputedStyle(layoutElement).paddingTop, 10)

  return window.innerHeight - wrapper.offsetHeight - layoutElementPadding
}
